import s from '../styles/jujitsu-grades.module.css';
import OJLayout from '../components/layout';
import Head from 'next/head'
import Image from 'next/image'
import Link from 'next/link'
import * as envConstants from '../components/constants';

export default function JujitsuGrades() {
    return (
    <OJLayout>
        <Head><title>{envConstants.SITE_NAME_OJ} - Grades</title></Head>
        <div className={s.divJGrades} >
            {/* Titre de la page */}
            <p className={s.title}>les Grades</p>
            {/* Liens internes Page */}
            <div className={s.divLieninterne}>
                <Link href={"#grades-kyu"}><a className={s.GradesLieninterne}>Les Kyū : ceintures de couleur</a></Link>
                <Link href={"#grades-dan"}><a className={s.GradesLieninterne}>Les Dan : grades supérieurs</a></Link>
            </div>
            <div className={s.divSepartion}/>
            {/* Image Ceintures Kyu */}
            <div id="grades-kyu" className={s.divCeintures}>
                <Image alt="grades kuy" src="/images/grades-ceintures-kyu.png" width={600} height={880} />                
            </div>
            <div className={s.divSepartion}/>
            {/* Image Ceintures Dan */}
            <div id="grades-dan" className={s.divCeintures}>
                <Image alt="grades dan" src="/images/grades-ceintures-dan.png" width={850} height={850} />                
            </div>
            <p className={s.divCeintures}>Ces grades sont les mêmes que l'on retrouve au Judo.</p>
            <p className={s.divCeintures}>Attention : pour le Jiu Jitsu Brésilien, d'autres grades sont appliqués.</p>
        </div>
    </OJLayout>
)}